import {createReducer, on} from '@ngrx/store';
import {
  clearStartManyDestinationsState,
  startManyDestinations,
  startManyDestinationsFailure,
  startManyDestinationsSuccess
} from './destination.start-many.actions';
import {Destination} from '../../../services/api/destinations/destination.model';


export interface State {
  record: Destination[] | null;
  error: any | null;
  loaded: boolean;
  loading: boolean;
}

export const initialState: State = {
  record: null,
  error: null,
  loaded: false,
  loading: false
};


export const startManyDestinationsReducer = createReducer(
  initialState,

  on(startManyDestinations, (): State => ({
    record: null,
    error: null,
    loaded: false,
    loading: true
  })),
  on(startManyDestinationsSuccess, (): State => ({
    record: null,
    error: null,
    loaded: true,
    loading: false
  })),
  on(startManyDestinationsFailure, (_state: State, action): State => ({
    record: null,
    error: action.error,
    loaded: false,
    loading: false
  })),
  on(clearStartManyDestinationsState, (): State => ({
    record: null,
    error: null,
    loaded: false,
    loading: false
  }))
);

